import { forwardRef, type ComponentProps } from "react";
import { cn } from "src/shadcn/lib/utils";
import { Button as ShadcnButton } from "src/shadcn/components/button";

const Button = forwardRef<
  HTMLButtonElement,
  ComponentProps<typeof ShadcnButton>
>(({ className, ...props }, ref) => (
  <ShadcnButton
    ref={ref}
    className={cn(
      "data-[variant=default]:hover:bg-primary/90",
      "data-[variant=link]:rounded-none",
      className
    )}
    {...props}
  />
));

Button.displayName = "Button";

export { Button };
export { buttonVariants } from "src/shadcn/components/button";
